const mixin = {
  data() {
    return {
      dom: "",
      page: "",
      size: "",
      total: "",
      getDataFunc: null,
    };
  },
  methods: {
    // 获取两个日期之间的天数
    getDaysBetween(startDate, endDate) {
      let startTime = Date.parse(startDate);
      let endTime = Date.parse(endDate);
      if (startTime > startTime) {
        return 0;
      }
      if (startTime == endTime) {
        return 1;
      }
      let days = Math.ceil((endTime - startTime) / (1 * 24 * 60 * 60 * 1000));
      return days;
    },
    // 滚动懒加载
    handleScrollLazy(dom, page, size, total, getDataFunc) {
      this.dom = dom;
      this.page = page;
      this.size = size;
      this.total = total;
      this.getDataFunc = getDataFunc;
      dom.addEventListener("scroll", this.throttle(this.handleScroll));
    },
    // 节流函数
    throttle(func, time = 1000) {
      let t = null;
      return function () {
        if (t) return;
        t = setTimeout(() => {
          func.call(this);
          t = null;
        }, time);
      };
    },
    handleScroll() {
      let isLazy = false;
      const scrollDistance =
        this.dom.scrollHeight - this.dom.scrollTop - this.dom.clientHeight;
      if (scrollDistance < 1) {
        if (this.page >= Math.ceil(this.total / this.size)) {     
          isLazy = false;
          this.$toast.fail('已经到底了！');
        }
        if (this.page < Math.ceil(this.total / this.size)) {
          this.page++;
          isLazy = true;
          this.getDataFunc(this.page, isLazy);
        }
      }
    },
    setVagueString(inputStr, pos) {
      var outputStr = inputStr
        .split("")
        .map((char, index) => {
          if (pos.includes(index)) {
            return "*";
          }
          return char;
        })
        .join("");
      return outputStr;
    },
  },
};
export default mixin;
